module.exports = __webpack_public_path__ + "img/drop.6573381f.svg";